import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScrumboardService } from '../../scrumboard.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { MatDialog } from '@angular/material';
import { FormControl } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { ExcelService } from '../../excel.service';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { ScrumboardCardDialogComponent } from '../dialogs/card/card.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-sprint-list',
  templateUrl: './sprint-list.component.html',
  styleUrls: ['./sprint-list.component.scss'],
  animations: fuseAnimations
})

export class SprintListComponent implements OnInit {

  title = 'Angular Charts';
  view: any[];
  // options for the chart
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Count';
  yAxisLabel = 'Project Members';
  showYAxisLabel = true;
  timeline = true;
  colorScheme = {
    domain: ['#9370DB', '#008080', '#999999', '#5AA454', '#808000', '#C7B42C']

  };
  showLabels = true;

  barGaphData: any;
  dragOutGaphData: any;
  linedata: any;
  boardList = [];
  stackedGaphData = [];
  sprintList = [];
  sprintListDropDown = [];
  listOfSprints = [];
  nextSprint: any;
  board: any;
  private _unsubscribeAll: Subject<any>;
  projectId: any;
  projectName: any;
  sprintListCount: any;
  activeSprintCount: any;
  closedSprintCount: any;
  sprintForm: FormGroup;
  activeSprintLink: any;
  workItemsLink: any;
  sprintLink: any;
  sprintTasks = [];
  labelList = [];
  listOfTaskType = [];
  sprintStatus: any;
  boardId: any;
  backlogLink: string;
  taskCount: number;
  filteredOptions: Observable<any[]>;
  myControl = new FormControl();
  selectedSprint: any = { name: '', id: '' };
  selectedReport: any = { name: '', id: '' };
  cols: any[];
  sprintName: any;
  sprintSelected = '';
  activeSprintId: any;
  activeSprintName: any;
  activeSprintResults = [];
  statusOfSprint: any;
  nextSprintTodoId: any;
  nextSprintInprogressId: any;
  nextSprintCompletedId: any;
  nextSprintReopenId: any;
  nextSprintReadyforQaId: any;
  selectedProject: any = { name: '', id: '' };
  options: { legend: { position: string; }; };
  showFilter: boolean;
  projectMembers = [];
  tabIndex: Number;
  backlogBoardListId: any;
  assigneeId = [];
  priorityValue = [];
  typeOfTaskValue = [];
  cities = [];
  selectedCity: any;
  backlogBoard: any[];
  matMenuSprintList = [];
  empRole: any;
  currentSprintToDoId: any;
  currentSptintInprogress: any;
  currentSprintCompletedId: any;
  currentSprintReadyQaId: any;
  ReopenId: any;
  pendingTask = [];
  noData: boolean;
  yScaleMax = 0;
  ngxChartWidth = 1.7
  excelData = [];
  OldSprintValue: FormGroup;
  newSprintValue: any;
  OldSprintName: any;
  @ViewChild("sprintPopup", { static: false }) sprintPopup: TemplateRef<any>;
  dialogRef: any;
  reportListDropDown = [];
  totalRecords = 0;
  searchedTitle = '';
  skipValue: any;
  searchType: string;
  boardListTotalTasks = [];
  boardListTodoCount = [];
  boardListInprogressCount = [];
  boardListCompletedCount = [];
  sprintClose = false;

  constructor(
    private _scrumboardService: ScrumboardService,
    private storageConfiguration: StorageConfiguration,
    private route: ActivatedRoute,
    private parseService: ParseService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private excelService: ExcelService,
    private hardCodedValues: HardCodedValues,
    private activityCenterService: ActivityCenterService,
    private spinner: NgxSpinnerService

  ) {
    this._unsubscribeAll = new Subject();

    this.sprintForm = this.formBuilder.group({
      sprintName: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      sprintGoal: ['', Validators.required]
    });

    this.cols = [
      { field: 'position', header: 'Position' },
      { field: 'title', header: 'Title' },
      { field: 'priority', header: 'Priority' },
      { field: 'assignee', header: 'Assignees' },
      { field: 'status', header: 'Status' }
    ];

    this.options = {
      legend: {
        position: 'top'
      }
    };

  }

  async ngOnInit() {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);

    this._scrumboardService.onBoardChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(board => {
      this.board = board;
    });
    this.getBoardList();

    this.route.params.subscribe(async params => {
      this.projectId = params.boardId;
      this.projectName = params.boardUri;
      await this.getActiveSprint();
      await this.selectTab(0);
      // this.getSprintList();

      this.getProMembers(this.projectId);
      this.getBacklogBoardId();
    });
    this.getLabels();
  }

  async getActiveSprint() {
    let relationResult = [];
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('status', 'Active');
    await query.find().then(async results => {
      if (results.length > 0) {
        this.boardId = results[0].id;
        this.selectedSprint = {
          id: results[0].id,
          name: results[0].get('name') + ' - ' + results[0].get('status'),
          startDate: results[0].get('startDate'),
          endDate: results[0].get('endDate'),
          status: results[0].get('status'),
          createdAt: results[0].get('createdAt'),
        }
        this.selectedReport = this.selectedSprint;
        await this.getRelations(results[0].get('BoardLists')).then(result => {
          relationResult = result;
        });
        relationResult.forEach(element => {
          if (element.get('name') != 'Closed') {
            this.getRelations(element.get('Tasks')).then(res => {
              this.pendingTask = res;
            });
          }
          if (element.get('name') == 'To Do') {
            this.currentSprintToDoId = element.id
          } if (element.get('name') == 'In-Progress') {
            this.currentSptintInprogress = element.id
          } if (element.get('name') == 'Completed') {
            this.currentSprintCompletedId = element.id
          } if (element.get('name') == 'Ready for QA') {
            this.currentSprintReadyQaId = element.id
          } if (element.get('name') == 'Re-Open') {
            this.ReopenId = element.id
          }

          let index = results.indexOf({ boardId: element.id, boardName: element.get('name') });
          if (index == -1) {
            results.push({ boardId: element.id, boardName: element.get('name') });
          }
        });
      }
    });
  }

  async getBacklogBoardId() {
    let queryInstance = this.parseService.instance.Object.extend('ProjectBoardLists');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('name', 'Backlogs');
    await query.find().then(results => {
      this.backlogBoardListId = results[0].id
    });
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.excelData, this.selectedSprint.name);
  }

  async getLabels() {
    this.labelList = [];
    this.listOfTaskType = [];
    await this._scrumboardService.getLabels().then(async res => {
      let result = res[0];
      this.labelList = result.get('taskType');

      this.listOfTaskType = result.get('typeOfTask');
    });
  }

  async getSprintList() {
    this.sprintList = [];
    let resultArray = [];
    this.matMenuSprintList = [];
    let matmenuSprintList = [];
    this.reportListDropDown = [];

    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    await query.find().then(results => {
      results.forEach(async element => {
        resultArray.push({
          id: element.id,
          name: element.get('name') + ' - ' + element.get('status'),
          startDate: element.get('startDate'),
          endDate: element.get('endDate'),
          status: element.get('status'),
          createdAt: element.get('createdAt'),
        });
        matmenuSprintList.push({
          id: element.id,
          name: element.get('name'),
          startDate: element.get('startDate'),
          endDate: element.get('endDate'),
          status: element.get('status'),
          createdAt: element.get('createdAt'),
        });
        this.matMenuSprintList = matmenuSprintList.filter(x => (x.id != this.selectedSprint.id) && (x.status != 'Closed'));
      });

      this.reportListDropDown = resultArray.filter(x => x.name != 'Backlogs - New');
      this.sprintListDropDown = resultArray.filter(x => x.name != 'Backlogs - New' && x.status == 'New' || x.status == 'Active');

      this.sprintList = resultArray.sort((a, b) => {
        if ((a.createdAt).getTime() < (b.createdAt).getTime()) { return -1; }
        if ((a.createdAt).getTime() > (b.createdAt).getTime()) { return 1; }
      });

      let result = resultArray.filter(x => x.status != 'Active' && x.status != 'Closed' && x.name != 'Backlogs - New');
      this.listOfSprints = result.sort((a, b) => {
        if ((a.createdAt).getTime() < (b.createdAt).getTime()) { return -1; }
        if ((a.createdAt).getTime() > (b.createdAt).getTime()) { return 1; }
      });
      this.nextSprint = this.listOfSprints[0];
      this.getNextSprintsBoardListId(this.nextSprint);
      let activeSprint = this.sprintList.filter(x => x.status == 'Active');
      activeSprint.forEach(res => {
        this.activeSprintId = res.id;
        this.activeSprintName = res.name;
        if (this.activeSprintId != undefined) {
          if (this.tabIndex == 0) {
            this.getSprintTasks();
          }
        }
      });
      this.sprintListCount = this.sprintList.length;
    });
  }

  async getSprintTasks() {
    this.spinner.show();
    let i = 0;
    this.sprintSelected = this.selectedSprint.name == '' ? this.activeSprintName : this.selectedSprint.name;
    this.sprintTasks = [];
    this.excelData = [];
    let id = this.selectedSprint.id == '' ? this.activeSprintId : this.selectedSprint.id;

    await this._scrumboardService.getBoard(id, 'inActive');

    let queryInstance = this.parseService.instance.Object.extend('Tasks');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('Project');
    query.include('sprintId');
    query.equalTo('sprintId', { __type: 'Pointer', className: 'Sprint', objectId: id });
    query.limit(10);
    query.withCount();
    query.descending('updatedAt');
    if (this.skipValue != undefined) {
      query.skip(this.skipValue);
    }
    if (this.searchedTitle != '') {
      if (this.searchType == 'String') {
        query.contains('title', this.searchedTitle);
      }
      if (this.searchType == 'Number') {
        query.equalTo('cardNumber', Number(this.searchedTitle));
      }
    }
    if (this.priorityValue.length > 0) {
      query.containedIn('priority', [this.priorityValue]);
    }
    if (this.typeOfTaskValue.length > 0) {
      query.containedIn('typeOfTask', [this.typeOfTaskValue]);
    }
    if (this.assigneeId.length > 0) {
      query.containedIn('assigneesId', this.assigneeId);
    }
    let taskResult = await query.find();
    for (const res of taskResult.results) {
      this.sprintName = res.get('sprintId').get('name');
      this.statusOfSprint = res.get('sprintId').get('status');
      let assignee = await this.getAssignees(res.get('assignee'));
      let assignees = [];
      assignee.forEach(res => {
        assignees.push(res.name);
      });
      i = i + 1;

      this.sprintTasks.push({
        sprintId: id,
        listId: res.get('scrumboardList').id,
        id: res.id,
        title: res.get('title'),
        // priority: res.get('taskType'),
        priority: res.get('priority'),
        assignee: assignee,
        status: res.get('scrumboardList').get('name'),
        cardNumber: res.get('cardNumber'),
        typeOfTask: res.get('typeOfTask'),
        createdAt: res.get('createdAt'),
        taskRole: res.get('taskRole'),
        estimatedHours: this.secondsToHms(res.get('estimatedHours')),
        completedHours: this.secondsToHms(res.get('completedHours')),
      });

      this.excelData.push({
        'Serial No': i,
        'Title': res.get('title'),
        // 'Priority': res.get('taskType').slice(-1)[0],
        'Priority': res.get('priority'),
        'Type Of Task': res.get('typeOfTask').slice(-1)[0],
        'Card Number': res.get('cardNumber'),
        'Task Role': res.get('taskRole').slice(-1)[0],
        'Estimated Hours': this.secondsToHms(res.get('estimatedHours')),
        'Assignees': assignees.join()
      });
    }
    const taskGroupBy = this.groupBy(this.sprintTasks, 'status');
    // console.log('sprintTasks sprintTasks', taskGroupBy);
    for (const key in taskGroupBy) {
      if (key === 'To Do') {
        this.boardListTodoCount = taskGroupBy[key];
      }
      else if (key === 'In-Progress') {
        this.boardListInprogressCount = taskGroupBy[key];
      }
      else if (key === 'Completed') {
        this.boardListCompletedCount = taskGroupBy[key];
      }
    }
    this.boardListTotalTasks = this.sprintTasks;
    if (this.boardListCompletedCount.length === this.boardListTotalTasks.length) {
      this.sprintClose = true;
    }
    this.sprintTasks = this.uniqBy(this.sprintTasks, JSON.stringify);
    this.taskCount = this.sprintTasks.length;
    this.totalRecords = taskResult.count;
    this.spinner.hide();
  }
  // Accepts the array and key
  groupBy = (array, key) => {
    // Return the end result
    return array.reduce((result, currentValue) => {
      // If an array already present for key, push it to the array. Else create an array and push the object
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
      return result;
    }, {}); // empty object is the initial value for result object
  }

  nextPage(event) {
    let pageNumber = event.pageIndex + 1;
    let value = pageNumber * 10;
    this.skipValue = value - 10;
    this.getSprintTasks();
  }

  async getRelations(result) {
    var relationResult = [];
    await result.query().each(function (obj) {
      relationResult.push(obj);
    });
    return relationResult;
  }

  async getAssignees(tasks) {
    let assignee = [];
    await tasks.query().each(innerElement => {
      assignee.push({
        name: innerElement.get('firstName') + ' ' + innerElement.get('lastName'),
        profileId: innerElement.id,
        profilePic: innerElement.get('profileImageInfo').url
      });
    });
    return assignee;
  }

  async getNextSprintsBoardListId(nextSprint) {
    if (nextSprint != undefined) {
      let nextSprintBoard = [];
      let queryInstance = this.parseService.instance.Object.extend('Sprint');
      let query = new this.parseService.instance.Query(queryInstance);
      query.equalTo('objectId', nextSprint.id);
      await query.find().then(results => {
        let nextSprintResults = results[0];
        let nextBoardLists = nextSprintResults.get('BoardLists');
        nextBoardLists.query().each(results => {
          nextSprintBoard.push(results);

          nextSprintBoard.forEach(res => {
            if (res.get('name') == 'To Do') {
              this.nextSprintTodoId = res.id;

            } else if (res.get('name') == 'In-Progress') {
              this.nextSprintInprogressId = res.id;

            } else if (res.get('name') == 'Ready for QA') {
              this.nextSprintReadyforQaId = res.id;

            } else if (res.get('name') == 'Completed') {
              this.nextSprintCompletedId = res.id;

            } else if (res.get('name') == 'Re-Open') {
              this.nextSprintReopenId = res.id;
            }
          });
        });
      });
    }
  }

  async sprintconfirmPopup() {
    let id = this.selectedSprint.id == '' ? this.activeSprintId : this.selectedSprint.id;
    if (id != undefined) {
      let queryInstance = this.parseService.instance.Object.extend('Sprint');
      let query = new this.parseService.instance.Query(queryInstance);
      query.include('project');
      query.equalTo('objectId', id);
      await query.find().then(async results => {
        this.sprintStatus = results[0].get('status');
        // for (const task of results) {
        //   // This query is done by creating a relation and querying it
        //   let tasksRelation = task.relation('tasks');
        //   tasksRelation = await tasksRelation.query().find();
        //   this.boardListTotalTasks = tasksRelation;
        //   const boardListRelation = task.relation('BoardLists');
        //   const boardList = await boardListRelation.query().find();
        //   const boardListTotalTasks = [];
        //   for (const board of boardList) {
        //     const boardTaskRelation = board.relation('Tasks');
        //     const boardTasks = await boardTaskRelation.query().find();
        //     if (board.get('name') === 'Completed'){
        //       task.boardListCompletedCount = boardTasks.length;
        //       this.boardListCompletedCount =  boardTasks.length;
        //     }
        //     if (board.get('name') === 'To Do'){
        //       this.boardListTodoCount =  boardTasks.length;
        //     }
        //     if (board.get('name') === 'In-Progress'){
        //       this.boardListInprogressCount =  boardTasks.length;
        //     }
        //     if (boardTasks.length > 0){
        //       boardListTotalTasks.push(...boardTasks);
        //     }
        //   }
        // }

        this.sprintForm.patchValue({
          id: results[0].id,
          startDate: results[0].get('startDate'),
          endDate: results[0].get('endDate'),
          sprintName: results[0].get('name'),
          sprintGoal: results[0].get('sprintGoal')
        });

        this.OldSprintValue = this.sprintForm.value;
      });

      this.dialog.open(this.sprintPopup, {
        width: "500px"
      });
      this.getSprintList();
    }
  }

  async update() {
    return new Promise(async (resolve, reject) => {
      let formValue = this.sprintForm.value;
      let currentSprintId = this.selectedSprint.id == '' ? this.activeSprintId : this.selectedSprint.id

      this.newSprintValue = this.sprintForm.value;
      let activities = await this.activityCenterService.getActivity(this.OldSprintValue, this.newSprintValue, this.hardCodedValues.sprint);
      this.activityCenterService.createActivity(activities, this.hardCodedValues.sprint, currentSprintId);

      let queryInstance = this.parseService.instance.Object.extend('Sprint');
      let query = new this.parseService.instance.Query(queryInstance);
      query.include('project');
      query.equalTo('objectId', currentSprintId);
      query.select('tasks.scrumboardList');
      await query.find().then(async results => {
        var result = results[0];
        result.set('startDate', new Date(formValue.startDate));
        result.set('endDate', new Date(formValue.endDate));
        result.set('sprintGoal', formValue.sprintGoal);
        result.set('name', formValue.sprintName);
        result.save().then(rest => {
          this.toastr.success('Phase updated successfully');
          resolve(rest);
          this.dialog.closeAll();
        });
      });
    });
  }

  async startSprint(event) {
    return new Promise(async (resolve, reject) => {
      let queryInstance = this.parseService.instance.Object.extend('Sprint');
      let query = new this.parseService.instance.Query(queryInstance);
      query.include('project');
      query.equalTo('project', {
        __type: 'Pointer',
        className: 'Project',
        objectId: this.projectId
      });
      query.equalTo('status', 'Active');
      await query.find().then(async result => {
        this.activeSprintResults = result;
        if (this.activeSprintResults.length > 0) {
          this.toastr.warning('Please close the current active sprint');
        }
        else {
          let formValue = this.sprintForm.value;
          let currentSprintId = this.selectedSprint.id == '' ? this.activeSprintId : this.selectedSprint.id

          this.newSprintValue = this.sprintForm.value;
          let activities = await this.activityCenterService.getActivity(this.OldSprintValue, this.newSprintValue, this.hardCodedValues.sprint);
          this.activityCenterService.createActivity(activities, this.hardCodedValues.sprint, currentSprintId);

          let sprintActivities = [];
          let message = 'Started a Sprint ';
          let activity = this.activityCenterService.setActivityModel(message);
          sprintActivities.push(activity);
          this.activityCenterService.createActivity(sprintActivities, this.hardCodedValues.sprint, currentSprintId);

          let queryInstance = this.parseService.instance.Object.extend('Sprint');
          let query = new this.parseService.instance.Query(queryInstance);
          query.include('project');
          query.equalTo('objectId', currentSprintId);
          query.select('tasks.scrumboardList');
          await query.find().then(async results => {
            var result = results[0];
            result.set('startDate', formValue.startDate);
            result.set('endDate', formValue.endDate);
            result.set('sprintGoal', formValue.sprintGoal);
            result.set('name', formValue.sprintName);
            result.set('status', event);
            result.save().then(rest => {
              resolve(rest);
              this.toastr.success('Phase updated successfully');
              this.getSprintTasks();
              this.dialog.closeAll();
              this.getSprintList();
            });
          });
        }
      });
    });
  }

  async closeSprint(event): Promise<any> {
    if (this.sprintClose === false) {
      this.toastr.info('Complete all the tasks in this board to close the Phase');
      return;
    } else {
      let formValue = this.sprintForm.value;
      let currentSprintId = this.selectedSprint.id == '' ? this.activeSprintId : this.selectedSprint.id;
      return new Promise(async (resolve, reject) => {
        let queryInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(queryInstance);
        query.include('project');
        query.include('tasks');
        query.equalTo('objectId', currentSprintId);
        query.select('tasks.scrumboardList');
        await query.find().then(async results => {
          var result = results[0];
          // for (const task of results) {
          //   // This query is done by creating a relation and querying it
          //   const tasksRelation = task.relation('tasks');
          //   const relationTask = await tasksRelation.query().find();
          //   const boardListRelation = task.relation('BoardLists');
          //   const boardList = await boardListRelation.query().find();
          //   const boardListTotalTasks = [];
          //   for (const board of boardList) {
          //     const boardTaskRelation = board.relation('Tasks');
          //     const boardTasks = await boardTaskRelation.query().find();
          //     if (board.get('name') === 'Completed'){
          //       task.boardListCompletedCount = boardTasks.length;
          //     }
          //     if (boardTasks.length > 0){
          //       boardListTotalTasks.push(...boardTasks);
          //     }
          //   }
          //   task.boardListTask = JSON.parse(JSON.stringify(boardListTotalTasks));
          //   task.boardList = JSON.parse(JSON.stringify(boardList));
          //   task.tasksObjects =  JSON.parse(JSON.stringify(relationTask));
          //   if(task.boardListCompletedCount === task.boardListTask.length){

          //   }
          //   else {
          //     this.toastr.info('Complete all the tasks in this board to close the Phase');
          //     return ;
          //   }
          // }

          // console.log('sprint task result', result);
          let oldChartData = result.get('chartData');

          // let sprintNewQuery = new this.parseService.instance.Object('Sprint');
          // sprintNewQuery.id = this.nextSprint.id;
          // let newChartData = sprintNewQuery.get('chartData');

          let tasks = result.relation('tasks').query();
          tasks.include('scrumboardList');
          tasks.limit(1000000);
          await tasks.find().then(inerResult => {

            let inCompletedTasks = [];
            inerResult.forEach(element => {
              if (element.get('scrumboardList') != undefined) {
                if (element.get('scrumboardList').get('name') != 'Closed') {
                  inCompletedTasks.push(element);
                }
              }
            });

            if (this.nextSprint == undefined && inCompletedTasks.length > 0) {
              this.toastr.info('There is no future Phases available. Please create the future Phase and then close the current Phase', '', {
                timeOut: 10000
              });
            }
            else {

              inerResult.forEach(element => {
                /**
                 * Update Chart Data starts
                 */
                if (element.get('scrumboardList') != undefined) {
                  if (element.get('scrumboardList').get('name') != 'Closed') {
                    let sprintNewQuery = new this.parseService.instance.Object('Sprint');
                    sprintNewQuery.id = this.nextSprint.id;
                    let newChartData = sprintNewQuery.get('chartData');

                    let cardType = element.get('cardType');

                    let storyPoints = element.get('storyPoints');
                    storyPoints = storyPoints != '' ? Number(storyPoints) : 0;
                    let estimatedHours = element.get('estimatedHours');
                    cardType = 'Previous Sprint';
                    newChartData.storyPoints.previousSprint.total = newChartData.storyPoints.previousSprint.total + storyPoints;
                    newChartData.storyPoints.previousSprint.remaining = newChartData.storyPoints.previousSprint.remaining + storyPoints;
                    newChartData.tasks.previousSprint.total = newChartData.tasks.previousSprint.total + 1;
                    newChartData.tasks.previousSprint.remaining = newChartData.tasks.previousSprint.remaining + 1;
                    newChartData.hours.previousSprint.total = newChartData.hours.previousSprint.total + estimatedHours;
                    sprintNewQuery.set('chartData', newChartData);
                    result.set('chartData', oldChartData);
                    element.set('cardType', cardType);
                    sprintNewQuery.save();
                    element.save();
                  }
                  /**
                    * Update Chart Data ends
                    */
                  if (element.get('scrumboardList').get('name') == 'To Do') {
                    this.removeFromOldSprint(currentSprintId, element.id);
                    this.addToNewSprint(this.nextSprint.id, element.id);

                    this.taskRelationAdd(this.nextSprintTodoId, element.id);
                    this.taskRelationRemove(this.currentSprintToDoId, element.id);

                    this.sprintPointerAdd(this.nextSprint.id, element.id, this.nextSprintTodoId);
                  }
                  else if (element.get('scrumboardList').get('name') == 'In-Progress') {
                    this.removeFromOldSprint(currentSprintId, element.id);
                    this.addToNewSprint(this.nextSprint.id, element.id);

                    this.taskRelationAdd(this.nextSprintInprogressId, element.id);
                    this.taskRelationRemove(this.currentSptintInprogress, element.id);

                    this.sprintPointerAdd(this.nextSprint.id, element.id, this.nextSprintInprogressId);
                  }
                  else if (element.get('scrumboardList').get('name') == 'Completed') {
                    this.removeFromOldSprint(currentSprintId, element.id);
                    this.addToNewSprint(this.nextSprint.id, element.id);

                    this.taskRelationAdd(this.nextSprintCompletedId, element.id);
                    this.taskRelationRemove(this.currentSprintCompletedId, element.id);

                    this.sprintPointerAdd(this.nextSprint.id, element.id, this.nextSprintCompletedId);
                  }
                  else if (element.get('scrumboardList').get('name') == 'Ready for QA') {
                    this.removeFromOldSprint(currentSprintId, element.id);
                    this.addToNewSprint(this.nextSprint.id, element.id);

                    this.taskRelationAdd(this.nextSprintReadyforQaId, element.id);
                    this.taskRelationRemove(this.currentSprintReadyQaId, element.id);

                    this.sprintPointerAdd(this.nextSprint.id, element.id, this.nextSprintReadyforQaId);
                  }
                  else if (element.get('scrumboardList').get('name') == 'Re-Open') {
                    this.removeFromOldSprint(currentSprintId, element.id);
                    this.addToNewSprint(this.nextSprint.id, element.id);

                    this.taskRelationAdd(this.nextSprintReopenId, element.id);
                    this.taskRelationRemove(this.ReopenId, element.id);

                    this.sprintPointerAdd(this.nextSprint.id, element.id, this.nextSprintReopenId);
                  }
                }

              });

              result.set('startDate', formValue.startDate);
              result.set('endDate', formValue.endDate);
              result.set('sprintGoal', formValue.sprintGoal);
              result.set('name', formValue.sprintName);
              result.set('status', event);
              result.save().then(async rest => {
                this.toastr.success('Phase Updated Successfully');
                resolve(rest);

                this.newSprintValue = this.sprintForm.value;
                let activities = await this.activityCenterService.getActivity(this.OldSprintValue, this.newSprintValue, this.hardCodedValues.sprint);
                this.activityCenterService.createActivity(activities, this.hardCodedValues.sprint, currentSprintId);
                let sprintActivities = [];
                let message = 'Closed a Phase ';
                let activity = this.activityCenterService.setActivityModel(message);
                sprintActivities.push(activity);
                this.activityCenterService.createActivity(sprintActivities, this.hardCodedValues.sprint, currentSprintId);

                if (this.nextSprint != undefined) {
                  this.selectedSprint = {
                    id: this.nextSprint.id,
                    name: this.nextSprint.name,
                    startDate: this.nextSprint.startDate,
                    endDate: this.nextSprint.endDate,
                    status: this.nextSprint.status,
                    createdAt: this.nextSprint.createdAt,
                  }
                }
                this.getSprintTasks();
                this.getSprintList();

              }, reject);

              this.dialog.closeAll();
              this.getSprintList();
            }
          });
        });
      });
    }

  }

  removeFromOldSprint(currentSprintId, taskId) {
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', currentSprintId);
    query.find().then(res => {
      let result = res[0];
      this.OldSprintName = res[0].get('name');
      var queryProfile = new this.parseService.instance.Object('Tasks');
      queryProfile.id = taskId;
      var relation = result.relation('tasks');
      relation.remove(queryProfile);
      result.save().then(async (result) => {
      });
    });
  }

  addToNewSprint(nextSprintId, taskId) {
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', nextSprintId);
    query.find().then(res => {
      let result = res[0];
      var queryProfile = new this.parseService.instance.Object('Tasks');
      queryProfile.id = taskId;
      var relation = result.relation('tasks');
      relation.add(queryProfile);
      result.save().then(async (result) => {
      });
    });
  }

  taskRelationAdd(boardId, taskId) {
    let queryInstance = this.parseService.instance.Object.extend('ProjectBoardLists');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', boardId);
    query.find().then(res => {
      let result = res[0];
      var queryProfile = new this.parseService.instance.Object('Tasks');
      queryProfile.id = taskId;
      var relation = result.relation('Tasks');
      relation.add(queryProfile);
      result.save().then(async (result) => {
      });
    });
  }

  taskRelationRemove(boardId, taskId) {
    let queryInstance = this.parseService.instance.Object.extend('ProjectBoardLists');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', boardId);
    query.find().then(res => {
      let result = res[0];
      var queryProfile = new this.parseService.instance.Object('Tasks');
      queryProfile.id = taskId;
      var relation = result.relation('Tasks');
      relation.remove(queryProfile);
      result.save().then(async (result) => {
      });
    });
  }

  async getBoardList() {
    this.boardList = [];
    let boardInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(boardInstance);
    await query.find().then(results => {
      let result = results[0];
      let listOfBoards = result.get('boardList');
      listOfBoards.forEach(element => {
        this.boardList.push(element.name);
      });
    });
  }

  async getBarGraph() {
    let barGraphResults = [];
    this.sprintSelected = this.selectedReport.name == '' ? this.activeSprintName : this.selectedReport.name;
    this.sprintTasks = [];
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    let id = this.selectedReport.id == '' ? this.activeSprintId : this.selectedReport.id
    query.include('project');
    query.equalTo('objectId', id);
    query.select('tasks.scrumboardList');
    await query.find().then(async results => {
      this.sprintName = results[0].get('name');
      this.statusOfSprint = results[0].get('status');
      let result = results[0];
      let tasks = result.relation('tasks').query();
      tasks.limit(100000);
      tasks.include('scrumboardList')
      let taskNames = [];
      let taskStatus = [];
      await tasks.find().then(taskResult => {
        this.getStackedGraph(taskResult);
        barGraphResults = JSON.parse(JSON.stringify(taskResult));
        this.boardList.forEach(result => {
          let res = barGraphResults.filter(x => x.scrumboardList.name == result);
          taskNames.push(result);
          taskStatus.push(res.length);
        });
        this.barGaphData = {
          labels: taskNames,
          datasets: [
            {
              data: taskStatus,
              backgroundColor: [
                '#9370DB',
                '#008080',
                '#999999',
                '#C7B42C',
                '#808000',
                '#5AA454'
              ],
              hoverBackgroundColor: [
                '#9370DB',
                '#008080',
                '#999999',
                '#C7B42C',
                '#808000',
                '#5AA454'
              ]
            }]
        }
        let findData = taskStatus.filter(e => e > 0);
        if (findData.length > 0) {
          this.noData = false;
        }
        else {
          this.noData = true;
        }

      });
    });
  }

  async getProMembers(projectId) {
    await this._scrumboardService.getProjectMembers(projectId).then(async results => {
      results.forEach(element => {
        this.projectMembers.push({
          profileId: element.get('user').get('profile').id,
          userName: element.get('user').get('profile').get('firstName') + ' ' + element.get('user').get('profile').get('lastName'),
          userImage: element.get('user').get('profile').get('profileImageInfo').url,
        })
      });
    });
  }

  formatYaxisTicks(val) {
    if (val % 1 === 0) {
      return val.toLocaleString();
    } else {
      return '';
    }
  }

  async getStackedGraph(taskResult) {
    let uniqueGraphData = [];
    let yMax = []
    let nextMultipleOfFive = 0;
    await this.projectMembers.forEach(async result => {
      var queryProfile = new this.parseService.instance.Object('Profile');
      queryProfile.id = result.profileId;
      let results = taskResult.filter(task => task.get('assigneesId').find(profileId => profileId == result.profileId));
      let series = [];
      this.boardList.forEach(innerresult => {
        let valueOfTask = results.filter(x => x.get('scrumboardList').get('name') == innerresult);
        series.push({
          name: innerresult,
          value: valueOfTask.length
        });
        uniqueGraphData.push({
          name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
          series: series
        });
        this.stackedGaphData = this.uniqBy(uniqueGraphData, JSON.stringify);
        /*
        Calculate max scale value in multiples of 5 yScaleMax
        */
        let taskCount = valueOfTask.length;
        if (taskCount % 5) {
          nextMultipleOfFive = taskCount + (5 - taskCount % 5);
        }
        if (yMax.length == 0) {
          yMax.push(nextMultipleOfFive);
        } else if (yMax[0] < nextMultipleOfFive) {
          yMax[0] = nextMultipleOfFive;
        }
        this.yScaleMax = yMax[0];
      });
    });
  }


  onResize(event) {
    this.view = [event.target.innerWidth / this.ngxChartWidth, 400];
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  async selectTab(index): Promise<void> {
    if (index == 0) {
      this.tabIndex = 0;
      await this.getSprintList();
    } else if (index == 1) {
      this.tabIndex = 1;
      await this.getSprintList();
      this.getBarGraph();
    }
  }

  async searchTask(event): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let i = 0;
      this.sprintTasks = [];
      if (event != undefined && event != '') {
        this.searchType = this.typeCheck(event);
        this.searchedTitle = event;
        this.getSprintTasks();
      }
      else {
        this.searchedTitle = '';
        this.getSprintTasks();
      }
    });
  }

  typeCheck(number): string {
    return (number == Number(number)) ? "Number" : "String"
  }

  async commonFilter() {
    this.getSprintTasks();
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay;
  }

  moveTask(sprintId, sprintName, oldSprintId, taskId, listId) {
    let relationResult;
    let newBoardListId;
    this.removeFromOldSprint(oldSprintId, taskId);
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', sprintId);
    query.find().then(async res => {
      let sprintResult = res[0];
      /**
       * Chart updates part 1 starts 
       */
      let newSprintstatus = sprintResult.get('status');
      let queryProfile = new this.parseService.instance.Object('Tasks');
      queryProfile.id = taskId;
      let cardType = queryProfile.get('cardType');
      let storyPoints = queryProfile.get('storyPoints');
      storyPoints = storyPoints != '' ? Number(storyPoints) : 0;
      let estimatedHours = queryProfile.get('estimatedHours');
      let newChartData = sprintResult.get('chartData');
      let sprintOldQuery = new this.parseService.instance.Object('Sprint');
      sprintOldQuery.id = oldSprintId;
      let oldChartData = sprintOldQuery.get('chartData');
      /**
       * Chart updates part 1 ends
       */
      await this.getRelations(sprintResult.get('BoardLists')).then(result => {
        relationResult = result;
      });
      if (sprintName != 'Backlogs') {
        relationResult.forEach(element => {
          if (element.get('name') == 'To Do') {
            newBoardListId = element.id
          }
        });
        /**
       * Chart updates part 2 starts
       */
        switch (cardType) {
          case 'Planned':
            oldChartData.storyPoints.planned.total = oldChartData.storyPoints.planned.total - storyPoints;
            oldChartData.tasks.planned.total = oldChartData.tasks.planned.total - 1;
            oldChartData.hours.planned.total = oldChartData.hours.planned.total - estimatedHours;
            oldChartData.storyPoints.planned.remaining = oldChartData.storyPoints.planned.remaining - storyPoints;
            oldChartData.tasks.planned.remaining = oldChartData.tasks.planned.remaining - 1;

            newChartData.storyPoints.planned.total = newChartData.storyPoints.planned.total + storyPoints;
            newChartData.tasks.planned.total = newChartData.tasks.planned.total + 1;
            newChartData.hours.planned.total = newChartData.hours.planned.total + estimatedHours;
            newChartData.storyPoints.planned.remaining = newChartData.storyPoints.planned.remaining + storyPoints;
            newChartData.tasks.planned.remaining = newChartData.tasks.planned.remaining + 1;
            cardType = newSprintstatus == 'New' ? 'Planned' : 'UnPlanned';
            break;
          case 'UnPlanned':
            oldChartData.storyPoints.unPlanned.total = oldChartData.storyPoints.unPlanned.total - storyPoints;
            oldChartData.tasks.unPlanned.total = oldChartData.tasks.unPlanned.total - 1;
            oldChartData.hours.unPlanned.total = oldChartData.hours.unPlanned.total - estimatedHours;
            oldChartData.storyPoints.unPlanned.remaining = oldChartData.storyPoints.unPlanned.remaining - storyPoints;
            oldChartData.tasks.unPlanned.remaining = oldChartData.tasks.unPlanned.remaining - 1;

            newChartData.storyPoints.unPlanned.total = newChartData.storyPoints.unPlanned.total + storyPoints;
            newChartData.tasks.unPlanned.total = newChartData.tasks.unPlanned.total + 1;
            newChartData.hours.unPlanned.total = newChartData.hours.unPlanned.total + estimatedHours;
            newChartData.storyPoints.unPlanned.remaining = newChartData.storyPoints.unPlanned.remaining + storyPoints;
            newChartData.tasks.unPlanned.remaining = newChartData.tasks.unPlanned.remaining + 1;
            cardType = newSprintstatus == 'New' ? 'Planned' : 'UnPlanned';
            break;
          case 'Previous Sprint':
            oldChartData.storyPoints.previousSprint.total = oldChartData.storyPoints.previousSprint.total - storyPoints;
            oldChartData.tasks.previousSprint.total = oldChartData.tasks.previousSprint.total - 1;
            oldChartData.hours.previousSprint.total = oldChartData.hours.previousSprint.total - estimatedHours;
            oldChartData.storyPoints.previousSprint.remaining = oldChartData.storyPoints.previousSprint.remaining - storyPoints;
            oldChartData.tasks.previousSprint.remaining = oldChartData.tasks.previousSprint.remaining - 1;

            newChartData.storyPoints.previousSprint.total = newChartData.storyPoints.previousSprint.total + storyPoints;
            newChartData.tasks.previousSprint.total = newChartData.tasks.previousSprint.total + 1;
            newChartData.hours.previousSprint.total = newChartData.hours.previousSprint.total + estimatedHours;
            newChartData.storyPoints.previousSprint.remaining = newChartData.storyPoints.previousSprint.remaining + storyPoints;
            newChartData.tasks.previousSprint.remaining = newChartData.tasks.previousSprint.remaining + 1;
            cardType = 'Previous Sprint';
            break;

          default:
            break;
        }
        /**
         * Chart updates part 2 ends
         */
      }
      else if (sprintName == 'Backlogs') {
        relationResult.forEach(element => {
          if (element.get('name') == 'Backlogs') {
            newBoardListId = element.id
          }
        });
        /**
         * Chart updates part 3 starts
         */
        switch (cardType) {
          case 'Planned':
            oldChartData.storyPoints.planned.total = oldChartData.storyPoints.planned.total - storyPoints;
            oldChartData.tasks.planned.total = oldChartData.tasks.planned.total - 1;
            oldChartData.hours.planned.total = oldChartData.hours.planned.total - estimatedHours;
            oldChartData.storyPoints.planned.remaining = oldChartData.storyPoints.planned.remaining - storyPoints;
            oldChartData.tasks.planned.remaining = oldChartData.tasks.planned.remaining - 1;

            oldChartData.storyPoints.movedToBacklogs = oldChartData.storyPoints.movedToBacklogs + storyPoints;
            oldChartData.tasks.movedToBacklogs = oldChartData.tasks.movedToBacklogs + 1;
            oldChartData.hours.movedToBacklogs = oldChartData.hours.movedToBacklogs + estimatedHours;

            break;
          case 'UnPlanned':
            oldChartData.storyPoints.unPlanned.total = oldChartData.storyPoints.unPlanned.total - storyPoints;
            oldChartData.tasks.unPlanned.total = oldChartData.tasks.unPlanned.total - 1;
            oldChartData.hours.unPlanned.total = oldChartData.hours.unPlanned.total - estimatedHours;
            oldChartData.storyPoints.unPlanned.remaining = oldChartData.storyPoints.unPlanned.remaining - storyPoints;
            oldChartData.tasks.unPlanned.remaining = oldChartData.tasks.unPlanned.remaining - 1;

            oldChartData.storyPoints.movedToBacklogs = oldChartData.storyPoints.movedToBacklogs + storyPoints;
            oldChartData.tasks.movedToBacklogs = oldChartData.tasks.movedToBacklogs + 1;
            oldChartData.hours.movedToBacklogs = oldChartData.hours.movedToBacklogs + estimatedHours;
            break;
          case 'Previous Sprint':
            oldChartData.storyPoints.previousSprint.total = oldChartData.storyPoints.previousSprint.total - storyPoints;
            oldChartData.tasks.previousSprint.total = oldChartData.tasks.previousSprint.total - 1;
            oldChartData.hours.previousSprint.total = oldChartData.hours.previousSprint.total - estimatedHours;
            oldChartData.storyPoints.previousSprint.remaining = oldChartData.storyPoints.previousSprint.remaining - storyPoints;
            oldChartData.tasks.previousSprint.remaining = oldChartData.tasks.previousSprint.remaining - 1;

            oldChartData.storyPoints.movedToBacklogs = oldChartData.storyPoints.movedToBacklogs + storyPoints;
            oldChartData.tasks.movedToBacklogs = oldChartData.tasks.movedToBacklogs + 1;
            oldChartData.hours.movedToBacklogs = oldChartData.hours.movedToBacklogs + estimatedHours;
            break;

          default:
            break;
        }
        cardType = 'Backlog';
      }
      sprintResult.set('chartData', newChartData);
      sprintOldQuery.set('chartData', oldChartData);
      queryProfile.set('cardType', cardType);
      sprintOldQuery.save();
      queryProfile.save();

      /**
       * Chart updates part 3 ends
       */
      let relation = sprintResult.relation('tasks');
      relation.add(queryProfile);
      sprintResult.save();
      this.addToNewBoardList(newBoardListId, queryProfile);
      this.removeFromOldList(queryProfile, listId);
      this.sprintPointerAdd(sprintId, taskId, newBoardListId);
      this.toastr.success('Task moved successfully');
      this.getSprintTasks();

      let activities = [];
      let message = 'Card Number' + ' ' + queryProfile.get('cardNumber') + ' ' + 'Moved from ' + this.OldSprintName + '  to' + ' ' + sprintResult.get('name');
      let activity = this.activityCenterService.setActivityModel(message);
      activities.push(activity);
      this.activityCenterService.createActivity(activities, this.hardCodedValues.sprint, sprintResult.id);

    });
  }

  addToNewBoardList(newBoardListId, task) {
    if (this.backlogBoardListId) {
      var queryRel = new this.parseService.instance.Query('ProjectBoardLists');
      queryRel.equalTo('objectId', newBoardListId);
      queryRel.first().then(res => {
        var relation = res.relation('Tasks');
        relation.add(task);
        res.save().then((result) => {
        });
        return res;
      });
    }
  }

  removeFromOldList(task, listId) {
    var queryRel = new this.parseService.instance.Query('ProjectBoardLists');
    queryRel.equalTo('objectId', listId);
    queryRel.first().then(function (res) {
      var relation = res.relation('Tasks');
      relation.remove(task);
      res.save().then((result) => {
      });
      return res;
    });
  }

  sprintPointerAdd(sprintId, taskId, nextSprintBoardListId) {
    let queryInstance = this.parseService.instance.Object.extend('Tasks');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('sprintId');
    query.equalTo('objectId', taskId);
    query.find().then(res => {
      let result = res[0];
      result.set('sprintId', {
        __type: 'Pointer',
        className: 'Sprint',
        objectId: sprintId
      });
      result.set('scrumboardList', {
        __type: 'Pointer',
        className: 'ProjectBoardLists',
        objectId: nextSprintBoardListId
      })
      result.save().then(result => {
      });
    });
  }


  async editCardDialog(cardId, listId): Promise<void> {
    this.dialogRef = this.dialog.open(ScrumboardCardDialogComponent, {
      panelClass: 'scrumboard-card-dialog',
      width: '1200px',
      data: {
        cardId: cardId,
        listId: listId,
        activeStatus: 'New'
      }
    });
    this.dialogRef.afterClosed().subscribe(response => {
    });
  }


  close() {
    this.dialog.closeAll();
  }

}
